import { type GetHookResponse } from '../hooks'
import { attachmentKey } from '../keys'
import { useTantalimQuery } from '../query'
import {
  type AttachmentData,
  type AttachmentGetInput,
  type AttachmentGetSuccess,
  type AttachmentId,
  HOUR,
} from '@terros/common'

export function useAttachment(attachmentId: AttachmentId): GetHookResponse<AttachmentData> {
  return useTantalimQuery<AttachmentGetInput, AttachmentGetSuccess, AttachmentData>({
    url: '/attachment/get',
    queryKey: attachmentKey(attachmentId),
    input: {
      attachmentId,
    },
    convertResponse: (data) => {
      return data.attachment
    },
    options: {
      staleTime: HOUR,
      gcTime: HOUR,
    },
  })
}
